
class ViewSDKClient {
    constructor() {
        (this as any).readyPromise = new Promise<void>((resolve) => {
            if ((window as any).AdobeDC) {
                resolve();
            } else {
                document.addEventListener("adobe_dc_view_sdk.ready", () => {
                    resolve();
                });
            }
        });
        (this as any).adobeDCView = undefined;
    }

    ready() {
        return  (this as any).readyPromise;
    }

    previewFile(divId: string, file: any, title: string, viewerConfig: any) {
        const config = {
            clientId: process.env.NODE_ENV === "development" ? "17f26e6a6e5143b9b8ad52bf033fdfc7" : "97404563c955481e865640e6a02b9080"
        } as any;
        if (divId) {
            config.divId = divId;
        }
        (this as any).adobeDCView = new (window as any).AdobeDC.View(config);

        const previewFilePromise = (this as any).adobeDCView.previewFile({
            content: {
                location: {
                    url: file,
                },
            },
            metaData: {
                fileName: title,
            }
        }, viewerConfig);

        return previewFilePromise;
    }
}

export default ViewSDKClient;